import cn from 'classnames';
import * as React from 'react';

import styles from './SendDate.module.scss';

interface IProps {
  className?: string;
  label: string;
  value: string;
}

const SendDate = ({ className, label, value }: IProps) => {
  return (
    <div className={cn(styles.container, className)}>
      <span className={styles.label}>{label}</span>
      {value}
    </div>
  );
};

export default SendDate;
